import 'css-chunksrc/client/scenes/resourceEdition/assignCalendarHolidaysToResource/calendarHolidaysSelection/styles.scss';export default {
  "calendarSelection": "_calendarSelection_1kqdt_1",
  "input": "_input_1kqdt_5",
  "selection": "_selection_1kqdt_18",
  "placeholder": "_placeholder_1kqdt_24",
  "list": "_list_1kqdt_28",
  "calendar": "_calendar_1kqdt_1",
  "iconBox": "_iconBox_1kqdt_59",
  "icon": "_icon_1kqdt_59",
  "opened": "_opened_1kqdt_69",
  "selected": "_selected_1kqdt_77",
  "selectedCalendarIcon": "_selectedCalendarIcon_1kqdt_81",
  "disabled": "_disabled_1kqdt_87",
  "clear": "_clear_1kqdt_93"
};